import { use } from "react";
import { useQuery } from "react-query";
import { useQueryClient } from "react-query";
import { useMutation } from "react-query";

import Alert from "components/atoms/alert/Alert";

import {
    getSideMenuInfo,
    getSpace,
    getUserProfile,
    patchGroupHide,
    patchSpace,
    patchUserProfile,
    userCheck,
} from "utils/request/auth";

export const useUser = (params) => {
    return useQuery("user", (e) => userCheck(params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const useUserProfile = (params) => {
    return useQuery(["userProfile", params], (e) => getUserProfile(params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const useUserProfileUpdate = () => {
    const queryClient = useQueryClient();

    return useMutation(patchUserProfile, {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: "userProfile" });
            queryClient.invalidateQueries({ queryKey: "user" });
        },
        onError: (e) => {
            Alert("warn", "에러", "서버에 오류가 발생하였습니다.");
        },
    });
};

export const useSideMenuInfo = () => {
    return useQuery("sideMenuInfo", () => getSideMenuInfo(), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const usePatchGroupHide = () => {
    const queryClient = useQueryClient();

    return useMutation(patchGroupHide, {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: "sideMenuInfo" });
        },
        onError: (e) => {
            Alert("warn", "에러", "서버에 오류가 발생하였습니다.");
        },
    });
};

export const useSpace = (options = {}) => {
    return useQuery("space", () => getSpace(), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
        ...options,
    });
};

export const usePatchSpace = () => {
    const queryClient = useQueryClient();

    return useMutation(patchSpace, {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: "space" });
        },
        onError: (e) => {
            Alert("warn", "에러", "서버에 오류가 발생하였습니다.");
        },
    });
};
